import { useEffect } from "react";
import skolkovoLogo from "@assets/Sk__-block-mono-cont_1779254187033.svg";
import "./landing.css";

const RATES = [
  { role: "Backend-разработка", rate: "от 4 000 ₽/час" },
  { role: "Frontend-разработка", rate: "от 4 000 ₽/час" },
  { role: "UI/UX-дизайн", rate: "от 3 500 ₽/час" },
  { role: "Тестирование (QA)", rate: "от 3 000 ₽/час" },
];

const STACK: { title: string; items: string[] }[] = [
  { title: "DevOps", items: ["Nginx", "Docker"] },
  {
    title: "Фронтенд",
    items: ["HTML", "SASS", "JavaScript", "TypeScript", "React", "Webpack", "Vue.js"],
  },
  {
    title: "Бэкенд",
    items: ["PHP", "Symfony", "Nginx", "Yii", "RabbitMQ", "GraphQL"],
  },
  { title: "Базы данных", items: ["MySQL"] },
  { title: "Тестирование", items: ["Postman"] },
  { title: "Дизайн", items: ["Figma"] },
];

const REQUISITES: { label: string; value: string }[] = [
  {
    label: "Компания",
    value:
      "ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ «ЭЛЕМЕНТАРИ-РЕСЕРЧ»",
  },
  { label: "ОГРН", value: "1157746912608" },
  { label: "ИНН", value: "7730187481" },
  { label: "КПП", value: "773101001" },
  {
    label: "Код вида деятельности в области ИТ",
    value:
      "1.01 (в соответствии с Приказом Министерства цифрового развития, связи и массовых коммуникаций РФ от 11 мая 2023 г. № 449)",
  },
  {
    label: "Исключительные права на ПО",
    value:
      "ООО «ЭЛЕМЕНТАРИ-РЕСЕРЧ» является обладателем исключительных прав на создаваемое программное обеспечение. Право использования программного обеспечения предоставляется на условиях лицензионного договора, который заключается с каждым лицензиатом",
  },
];

function HeroDiagram() {
  return (
    <svg
      className="er-hero-svg"
      viewBox="0 0 560 420"
      role="img"
      aria-label="Изометричная иллюстрация рабочего стола разработчика"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="er-glow" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#7cc4ff" stopOpacity="0.35" />
          <stop offset="100%" stopColor="#7cc4ff" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="er-panel" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#1a2240" />
          <stop offset="100%" stopColor="#0f152a" />
        </linearGradient>
        <linearGradient id="er-panel-light" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#22304f" />
          <stop offset="100%" stopColor="#161e38" />
        </linearGradient>
      </defs>

      {/* ambient glow */}
      <ellipse cx="280" cy="380" rx="220" ry="24" fill="url(#er-glow)" />

      {/* === Back panel (terminal) === */}
      <g transform="translate(120,40)">
        <polygon
          points="0,40 200,0 320,60 120,100"
          fill="url(#er-panel-light)"
          stroke="rgba(124,196,255,0.35)"
        />
        {/* terminal screen */}
        <g opacity="0.95">
          <polygon
            points="22,46 196,12 196,16 22,50"
            fill="#7cc4ff"
            opacity="0.55"
          />
          <polygon
            points="22,56 150,32 150,36 22,60"
            fill="#94a0bc"
            opacity="0.55"
          />
          <polygon
            points="22,66 178,38 178,42 22,70"
            fill="#94a0bc"
            opacity="0.4"
          />
          <polygon
            points="22,76 120,58 120,62 22,80"
            fill="#7cc4ff"
            opacity="0.5"
          />
          <polygon
            points="22,86 170,58 170,62 22,90"
            fill="#94a0bc"
            opacity="0.35"
          />
        </g>
      </g>

      {/* === Middle panel (browser/cards) === */}
      <g transform="translate(60,130)">
        <polygon
          points="0,60 220,0 360,80 140,140"
          fill="url(#er-panel)"
          stroke="rgba(124,196,255,0.4)"
        />
        {/* tab bar */}
        <polygon
          points="14,66 218,8 218,14 14,72"
          fill="rgba(124,196,255,0.18)"
        />
        {/* dots */}
        <circle cx="24" cy="70" r="3" fill="#7cc4ff" />
        <circle cx="34" cy="67" r="3" fill="#7cc4ff" opacity="0.7" />
        <circle cx="44" cy="64" r="3" fill="#7cc4ff" opacity="0.45" />

        {/* cards row */}
        <g>
          <polygon
            points="40,92 100,76 130,90 70,108"
            fill="#22304f"
            stroke="rgba(124,196,255,0.45)"
          />
          <polygon
            points="140,72 200,56 230,70 170,88"
            fill="#22304f"
            stroke="rgba(124,196,255,0.45)"
          />
          <polygon
            points="240,52 300,36 330,50 270,68"
            fill="#22304f"
            stroke="rgba(124,196,255,0.45)"
          />
        </g>
      </g>

      {/* === Front panel (code blocks) === */}
      <g transform="translate(160,240)">
        <polygon
          points="0,40 180,0 260,60 80,100"
          fill="url(#er-panel-light)"
          stroke="rgba(124,196,255,0.5)"
        />
        {/* code lines */}
        <polygon points="20,48 70,38 70,42 20,52" fill="#7cc4ff" opacity="0.8" />
        <polygon points="20,58 130,36 130,40 20,62" fill="#94a0bc" opacity="0.6" />
        <polygon points="30,68 110,52 110,56 30,72" fill="#94a0bc" opacity="0.6" />
        <polygon points="20,78 160,50 160,54 20,82" fill="#7cc4ff" opacity="0.7" />
        <polygon points="30,88 90,76 90,80 30,92" fill="#94a0bc" opacity="0.55" />
      </g>

      {/* sparkles */}
      <g fill="#7cc4ff">
        <circle cx="80" cy="80" r="2" opacity="0.8" />
        <circle cx="500" cy="160" r="2" opacity="0.8" />
        <circle cx="120" cy="380" r="2" opacity="0.6" />
        <circle cx="470" cy="350" r="2" opacity="0.6" />
      </g>
    </svg>
  );
}

function StackIcon({ name }: { name: string }) {
  const icons: Record<string, JSX.Element> = {
    DevOps: (
      <g>
        <circle cx="20" cy="20" r="14" />
        <path d="M20 6v28M6 20h28" />
      </g>
    ),
    Фронтенд: (
      <g>
        <rect x="4" y="6" width="32" height="22" rx="2" />
        <path d="M4 12h32M10 22l4-4-4-4M30 22l-4-4 4-4" />
      </g>
    ),
    Бэкенд: (
      <g>
        <rect x="6" y="6" width="28" height="8" rx="2" />
        <rect x="6" y="18" width="28" height="8" rx="2" />
        <circle cx="11" cy="10" r="1.5" fill="currentColor" />
        <circle cx="11" cy="22" r="1.5" fill="currentColor" />
      </g>
    ),
    "Базы данных": (
      <g>
        <ellipse cx="20" cy="8" rx="14" ry="4" />
        <path d="M6 8v20c0 2.2 6.3 4 14 4s14-1.8 14-4V8" />
        <path d="M6 18c0 2.2 6.3 4 14 4s14-1.8 14-4" />
      </g>
    ),
    Тестирование: (
      <g>
        <path d="M6 32l10-10M22 4l14 14M14 24l8-8M18 28l8-8" />
        <circle cx="11" cy="27" r="2" />
      </g>
    ),
    Дизайн: (
      <g>
        <path d="M6 30l8-2 16-16-6-6L8 22l-2 8z" />
        <path d="M24 8l6 6" />
      </g>
    ),
  };

  return (
    <svg
      className="er-stack-icon"
      viewBox="0 0 40 36"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {icons[name] ?? (
        <circle cx="20" cy="18" r="10" />
      )}
    </svg>
  );
}

function App() {
  useEffect(() => {
    document.title =
      "Elementari Research — разработка программного обеспечения";
  }, []);

  return (
    <div className="er-root">
      <header className="er-header">
        <div className="er-container er-header-inner">
          <a href="#top" className="er-logo">
            <span className="er-logo-mark" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="6" cy="5" r="2" stroke="currentColor" strokeWidth="2" />
                <circle cx="18" cy="5" r="2" stroke="currentColor" strokeWidth="2" />
                <circle cx="12" cy="19" r="2" stroke="currentColor" strokeWidth="2" />
                <path
                  d="M6 7 V11 a3 3 0 0 0 3 3 H15 a3 3 0 0 0 3 -3 V7"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  fill="none"
                />
                <path
                  d="M12 14 V17"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </span>
            <span className="er-logo-text">
              <span className="er-logo-name">Elementaree Research</span>
            </span>
          </a>
        </div>
      </header>

      <main id="top">
        <section className="er-hero">
          <div className="er-container er-hero-inner">
            <div className="er-hero-text">
              <h1 className="er-h1">Разработка программного обеспечения</h1>
              <p className="er-lead">
                Проектируем, разрабатываем и сопровождаем веб-приложения и
                корпоративные системы под ключ
              </p>
            </div>
            <div className="er-hero-visual" aria-hidden="false">
              <HeroDiagram />
            </div>
          </div>
        </section>

        <section id="services" className="er-section">
          <div className="er-container">
            <h2 className="er-h2">Наши услуги</h2>

            <div className="er-card">
              <p className="er-body">
                Разработка программного обеспечения осуществляется по
                индивидуальному техническому заданию, поэтому итоговая
                стоимость услуг определяется отдельно для каждого проекта
              </p>
            </div>

            <div className="er-card">
              <h3 className="er-h3">Базовые ставки специалистов</h3>
              <div className="er-rates">
                {RATES.map((r) => (
                  <div key={r.role} className="er-rate">
                    <span className="er-rate-role">{r.role}</span>
                    <span className="er-rate-value">{r.rate}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="er-card er-card-highlight">
              <p className="er-highlight-text">
                Минимальная стоимость проекта — <strong>от 500 000 ₽</strong>
              </p>
            </div>

            <div className="er-card er-card-accent">
              <p>
                Окончательная стоимость определяется после анализа требований
                и фиксируется в коммерческом предложении и/или договоре
              </p>
            </div>
          </div>
        </section>

        <section id="stack" className="er-section er-section-alt">
          <div className="er-container">
            <h2 className="er-h2">Технологический стек</h2>
            <p className="er-section-lead">
              Современный и гибкий набор технологий, который охватывает все
              этапы разработки:
            </p>
            <div className="er-stack-grid">
              {STACK.map((group) => (
                <div key={group.title} className="er-stack-card">
                  <div className="er-stack-head">
                    <StackIcon name={group.title} />
                    <h3 className="er-stack-title">{group.title}</h3>
                  </div>
                  <ul className="er-tag-list">
                    {group.items.map((item) => (
                      <li key={`${group.title}-${item}`} className="er-tag">
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="requisites" className="er-section">
          <div className="er-container">
            <h2 className="er-h2">Реквизиты</h2>
            <div className="er-card">
              <dl className="er-req">
                {REQUISITES.map((r) => (
                  <div key={r.label} className="er-req-row">
                    <dt>{r.label}</dt>
                    <dd>{r.value}</dd>
                  </div>
                ))}
              </dl>
            </div>

            <h2 className="er-h2 er-h2-spaced">Контакты</h2>
            <div className="er-card">
              <dl className="er-req">
                <div className="er-req-row">
                  <dt>Юридический адрес</dt>
                  <dd>
                    Москва, б-р. Большой (инновационного центра Сколково Тер),
                    дом 42, стр. 1, этаж 1 пом.600 Рм4
                  </dd>
                </div>
                <div className="er-req-row">
                  <dt>Email</dt>
                  <dd>
                    <a href="mailto:accounting_reserch@elementaree.ru">
                      accounting_reserch@elementaree.ru
                    </a>
                  </dd>
                </div>
                <div className="er-req-row">
                  <dt>Телефон</dt>
                  <dd>
                    <a href="tel:+79251819416">+7 (925) 181-94-16</a>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </section>
      </main>

      <footer className="er-footer">
        <div className="er-container er-footer-inner">
          <span>© {new Date().getFullYear()} ООО «ЭЛЕМЕНТАРИ-РЕСЕРЧ»</span>
          <a
            href="https://sk.ru/"
            target="_blank"
            rel="noopener noreferrer"
            className="er-footer-logo-link"
            aria-label="Участник Сколково"
          >
            <img
              src={skolkovoLogo}
              alt="Участник Сколково"
              className="er-footer-logo"
            />
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
